import { faqs } from "@/mocks/comics";

export default function FAQSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于韩漫大全漫画网的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-100 rounded-lg overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-200/70 transition-colors">
                <h3 className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}